export interface EntraJobDetailLog {
  id: number; // uint
  job_id: number;
  job_name?: string; // может приходить с бэкенда при join
  entity_id: string;
  action: LogAction | string;
  changes_json: string;
  additional_data: string;
  timestamp: string; // System.DateTime
}

export enum LogAction {
  Insert = 'Insert',
  Update = 'Update',
  UpdateButWasDelete = 'UpdateButWasDelete',
  Delete = 'Delete',
  Error = 'Error',
  Warning = 'Warning',
  NoAction = 'NoAction',
}

export interface Value {
  value: EntraJobDetailLog[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

// init api object
function toAPI(data: Partial<EntraJobDetailLog>): any {
  return {
    id: data?.id || 0,
    job_id: data?.job_id || 0,
    job_name: data?.job_name || '',
    entity_id: data?.entity_id || '',
    action: data?.action || '',
    changes_json: data?.changes_json || '',
    additional_data: data?.additional_data || '',
    timestamp: data?.timestamp || '',
  };
}

function parse(data?: Partial<EntraJobDetailLog>): EntraJobDetailLog {
  return {
    id: data?.id || 0,
    job_id: data?.job_id || 0,
    job_name: data?.job_name || '',
    entity_id: data?.entity_id || '',
    action: data?.action || '',
    changes_json: data?.changes_json || '',
    additional_data: data?.additional_data || '',
    timestamp: data?.timestamp || '',
  };
}

export default {
  parse,
  toAPI: toAPI,
};

export interface EntraJobItem {
  id: number;
  job_name: string;
  job_description: string;
  job_interval: string;
  created?: string | null;
  created_by?: string | null;
  updated?: string | null;
  updated_by?: string | null;
  last_log_id?: number | null;
  last_started_at?: string | null;
  last_run_by?: string | null;
  last_status?: string | null;
  summary_data?: string | null;
  message?: string | null;
}
